module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-banner.5ffe0be2.jpg";